import { Checkbox, DataSource, Label, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiRequiredFieldStatus extends Layout {
    checkboxIsActive: Checkbox;
    labelRulesTitle: Label;
    sourceEdiDataRule: DataSource;
    sourceEdiRequiredFieldStatus: DataSource;
    tableEdiDataRule: Table;
    textboxFieldName: Textbox;
    textboxLocation: Textbox;
    textboxPassTest: Textbox;
    textboxRuleType: Textbox;
    textboxStopsToCheck: Textbox;
    textboxTableName: Textbox;
}
